import { BaseDataResponse } from '../../base/entities/BaseEntities';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseEntitiesResponse, BaseEntityResponse, BaseResponse, CompanyInfo, KeyValueEntity, SystemOptionEntity} from '@base/entities/BaseEntities';
import { BaseEndpoint } from "@base/endpoint/BaseEndpoint";
import { APIGatewayService } from "../gateway/APIGateway.service";


@Injectable()
export class SystemOptionsEndpoint extends BaseEndpoint  
{
    public constructor(api: APIGatewayService)
    {
        super("SystemOptions", api);
    }

    public GetOptions(): Observable<BaseEntitiesResponse<SystemOptionEntity>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetOptions');
    }

    public SaveOptions(options: SystemOptionEntity[]): Observable<BaseEntitiesResponse<SystemOptionEntity>> {
        return this.api.ExecutePostAction(this.ControllerName, 'SaveOptions', options, undefined);
    }

}
